let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ceU3x")).then(() => parcelRequire('iyPh3'));